module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/costume_01@3x-37a5eed0cc58445fd0231c808e7745b5.webp";